module.exports = __webpack_public_path__ + "img/three-dots.3e4aa4ee.svg";